import axios from 'axios';
import GLOBALS from "./GLOBALS";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  responseType: "json",
  headers: {
    "AuthType": GLOBALS.HEADERS_VALUES.PARTNER,
    "LoginType": 1
  }
});

// Add request interceptor to set authorization header dynamically
API.interceptors.request.use(
  function (config) {
    // Get current auth values from sessionStorage
    const userId = sessionStorage.getItem(GLOBALS.SESSION_KEYS.USER_ID);
    const token = sessionStorage.getItem(GLOBALS.SESSION_KEYS.TOKEN);
    
    if (userId && token) {
      config.headers.Authorization = userId + ":" + token;
    }
    
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);


// dev api: 'https://devapi.viewmind.net/'
// prod api: 'https://eu-api.viewmind.ai/'
export default API;
